<vbango-room-game
  [busy]="mechanismBusy"
  (secretSubmitted)="onMechanismSecret($event)"
></vbango-room-game>
